"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const TaskPage_1 = require("../../base/TaskPage");
const Chip_1 = require("../../../components/chip/Chip");
const Section_1 = require("../../../components/section/Section");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const autosave_1 = require("../../../../hooks/autosave");
const build_1 = require("@travelnest/entities/build");
const constants_1 = require("../../../../tasks/constants");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HOUSE_RULE_RESTRICTION_NAMES = ['smoking', 'pets', 'group bookings', 'infants allowed', 'children allowed'];
const replaceIfExists = (restrictions, toReplace) => {
    const currentIndex = restrictions.findIndex((r) => r.restriction_type === toReplace.restriction_type);
    if (currentIndex >= 0) {
        restrictions.splice(currentIndex, 1);
    }
    restrictions.push(toReplace);
    return restrictions;
};
const newRestriction = (restrictionType, allowed, propertyId) => {
    return {
        allowed,
        charge: 0,
        charge_type: 'none',
        property: propertyId,
        restriction_type: restrictionType
    };
};
exports.default = (props) => {
    var _a, _b, _c, _d, _e;
    const { property, viewState, update, lastSaved, getterError, updaterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const allRestrictions = (property === null || property === void 0 ? void 0 : property.restrictions) || [];
    const houseRulesRestrictions = (0, build_1.keyEntitiesBy)(allRestrictions.filter((r) => HOUSE_RULE_RESTRICTION_NAMES.includes(r.restriction_type)), 'restriction_type');
    const updateRestrictionSelection = (restrictionType, selected) => {
        let restriction = houseRulesRestrictions[restrictionType];
        if (!restriction) {
            restriction = newRestriction(restrictionType, selected, props.propertyId);
        }
        else {
            restriction.allowed = selected;
        }
        update({ restrictions: replaceIfExists(allRestrictions, restriction) });
    };
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.HOUSE_RULES, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(Section_1.Section, { heading: "Family rules" },
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Chip_1.ChipQuestion, { question: "Which of the following are allowed to stay in your property?" },
                        React.createElement(Chip_1.Chip, { selected: !!((_a = houseRulesRestrictions['children allowed']) === null || _a === void 0 ? void 0 : _a.allowed), onChange: (_, selected) => updateRestrictionSelection('children allowed', selected), id: "children", text: "Children" }),
                        React.createElement(Chip_1.Chip, { selected: !!((_b = houseRulesRestrictions['infants allowed']) === null || _b === void 0 ? void 0 : _b.allowed), onChange: (_, selected) => updateRestrictionSelection('infants allowed', selected), id: "infants", text: "Infants" }))),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(HorizontalRule_1.HorizontalRule, null),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(Section_1.Section, { heading: "Recreational rules" },
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Chip_1.ChipQuestion, { question: "Which of the following are permitted inside your property?" },
                        React.createElement(Chip_1.Chip, { selected: !!((_c = houseRulesRestrictions.smoking) === null || _c === void 0 ? void 0 : _c.allowed), onChange: (_, selected) => updateRestrictionSelection('smoking', selected), id: "smoking", text: "Smoking" }),
                        React.createElement(Chip_1.Chip, { selected: !!((_d = houseRulesRestrictions['group bookings']) === null || _d === void 0 ? void 0 : _d.allowed), onChange: (_, selected) => updateRestrictionSelection('group bookings', selected), id: "parties", text: "Parties / Events" }),
                        React.createElement(Chip_1.Chip, { selected: !!((_e = houseRulesRestrictions.pets) === null || _e === void 0 ? void 0 : _e.allowed), onChange: (_, selected) => updateRestrictionSelection('pets', selected), id: "pets", text: "Pets" }))),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'pet-friendly', text: "Making your property pet-friendly will help to attract more bookings." }))))));
};
//# sourceMappingURL=HouseRulesPage.js.map